
import { REZERVATION_REQUEST } from '~/plugins/rezzervation'
export default {
  props: {
    activeUser: {
      default: () => {},
    },
    selectedPayment: {
      default: () => {},
    },
    activePackage: {
      default: () => {},
    },
  },
  data() {
    return {
      code: '',
      showCodeInput: false,
      isLoadingLogin: false,
      alertBox: { status: false, variant: '', message: '' },
    }
  },
  methods: {
    async GET_USER_INFORMATION() {
      this.alertBox.status = false
      const response = await REZERVATION_REQUEST(
        'Customers/ExternalLogin',
        'POST',
        {
          CompanyId:
            this.$store.getters['seances/getCompanyRezzervationInformation'].Id,
          Fullname: this.activeUser.fullname,
          Email: this.activeUser.email,
        }
      )
      if (response.message === 'OK') {
        this.alertBox = {
          status: true,
          message: 'Satın alma işleminiz gerçekleştiriliyor...',
          variant: 'success',
        }
        this.$emit('response:success', response.data.Id)
      }
    },
  },
  mounted() {
    this.GET_USER_INFORMATION()
  },
}
